import React, { useState } from "react";
import Layout from "../Layout";
import { Link } from "react-router-dom";
import { Button } from "../components/Form";
import { FaSave } from "react-icons/fa";
import { useNavigate } from "react-router";
import { FaBarsProgress } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import { FaAngleRight } from "react-icons/fa6";
import Popup from './Popup';
import { BiPlus } from "react-icons/bi";
import Updateworklog from './Updateworklog';
import { IoChatbubblesOutline } from "react-icons/io5";

const cardData = [
  {
    name: "ali",
    surname: "zahra",
    finishDate: "06/08/2024, 12:00 PM",
    shipDate: "06/02/2024, 12:00 PM"
  },
  {
    name: "salik",
    surname: "hafifa",
    finishDate: "06/08/2024, 12:00 PM",
    shipDate: "06/02/2024, 12:00 PM"
  },
  {
    name: "ali",
    surname: "zahra",
    finishDate: "06/08/2024, 12:00 PM",
    shipDate: "06/02/2024, 12:00 PM"
  },

];

function Dashboard() {

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isUpdateWorklogOpen, setIsUpdateWorklogOpen] = useState(false);
  const navigate = useNavigate();

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleRowClicked = (event) => {
    navigate(`/all-cases/${3454535}`)
  }
  const openUpdateWorklog = () => setIsUpdateWorklogOpen(true);
  const closeUpdateWorklog = () => setIsUpdateWorklogOpen(false);
  return (
    <Layout>
      {/* boxes */}
      <Link
        to="/add-new-case"
        className="w-16 animate-bounce h-16 border border-border z-50 bg-subMain text-white rounded-full flex-colo fixed bottom-8 right-12 button-fb"
      >
        <BiPlus className="text-2xl" />
      </Link>
      {cardData.length > 0 ? (
        <div className="grid  lg:grid-cols-3 grid-cols-1 gap-5 md:grid-cols-2">
          {cardData.map((card, index) => (
            <div key={index} className="rounded-lg shadow-lg p-6 bg-white space-y-2">
              <Link to={`/all-cases/${3454535}`} className="flex gap-3">
                <h1 className="text-xl text-black capitalize font-normal">{card.name}</h1>
                <h1 className="text-xl text-black capitalize font-normal italic">, {card.surname}</h1>
              </Link>

              <button className="flex gap-3 items-center" onClick={openPopup}>
                <FaBarsProgress className="text-[#1eae91]" />
                <h1 className="text-base text-[#92949c] font-normal">in progress</h1>
                <FaRegEdit className="text-[#92949c]" />
              </button>

              <p className="text-[#eb445a] text-sm font-normal">Finish Date: {card.finishDate}</p>
              <p className="text-[#eb445a] text-sm font-normal">Ship Date: {card.shipDate}</p>

              <h1 className="text-sm uppercase text-[#696969] font-semibold">work log</h1>
              <hr></hr>
              <button className="p-3 bg-[#f0f5fd] flex justify-between rounded-lg  items-center w-full text-start" onClick={openUpdateWorklog}>
                <IoChatbubblesOutline className="text-[#92949c]" />
                {/* <FaRegEdit className="text-[#92949c]" /> */}
                <div>
                  <h1 className="text-sm text-[#92949c] font-normal italic capitalize">test</h1>
                  <p className="text-base text-[#92949c] font-normal">06/02/2024, 11:20 AM</p>
                  <h1 className="text-base text-[#92949c] font-normal capitalize">waseem qasim</h1>
                </div>
                <FaAngleRight className="text-[#92949c]" />
              </button>
            </div>
          ))}

          <Popup isOpen={isPopupOpen} onClose={closePopup} />
          <Updateworklog isOpen={isUpdateWorklogOpen} onClose={closeUpdateWorklog} />

        </div>
      ) : (
        <div className="flex justify-center">
          <div className="flex flex-col max-w-[21rem] items-center">
            <img
              src="/images/logo.png"
              className="w-64"
              alt="logo"
            />
            <div className="flex justify-center items-center text-gray-500 text-md text-center my-5">
              Currently there is no active cases in your account. Please create new case.
            </div>
            <Button className={"my-4 mx-2"} label={"+ New Case"} Icon={FaSave} onClick={() => navigate("/add-new-case")} />
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Dashboard;
